import React, { Component } from 'react';
import { Container, Card, Icon, Grid, Header } from 'semantic-ui-react';
import scrollToElement from 'scroll-to-element';

class Navigation extends Component {
  render() {
    const { kriterierTittel, omTittel, bliKontaktetTittel } = this.props;

    const navigationItem = (title, onClick) => (
      <Card link color="green" onClick={onClick}>
        <Card.Content>
          <Grid verticalAlign="middle">
            <Grid.Column floated="left" width={11}>
              {title}
            </Grid.Column>
            <Grid.Column floated="right" textAlign="right" width={5}>
              <Icon name="angle right" size="large" />
            </Grid.Column>
          </Grid>
        </Card.Content>
      </Card>
    );

    return (
      <div className="navigasjon-wrapper">
        <Container>
          <Header as="h2" textAlign="center">
            Gå til seksjon
          </Header>
          <Card.Group itemsPerRow={4} doubling stackable className="navigasjon">
            {navigationItem(kriterierTittel, this.onClickPrinsipper)}
            {navigationItem(omTittel, this.onClickProsess)}
            {navigationItem(bliKontaktetTittel, this.onClickBliKontaktet)}
          </Card.Group>
        </Container>
      </div>
    );
  }

  onClickPrinsipper() {
    scrollToElement('#kriterier');
  }

  onClickProsess() {
    scrollToElement('#om');
  }

  onClickBliKontaktet() {
    scrollToElement('#bli-kontaktet');
  }
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/LandingPage/Navigation.js